import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class LoaderService {
    loaderSubject = new Subject<boolean>()
    loaderState = this.loaderSubject.asObservable()

    startLoading(): void {
        this.loaderSubject.next(true)
    }

    stopLoading(): void {
        this.loaderSubject.next(false)
    }
}
